import { NECRates, MBCBPRates, Assumptions, TaxBrackets } from '../Models/disability-calculator';

const NEC: NECRates = { "2025": 0.17, "Default": 0.18 };
const MBC_BP: MBCBPRates = { "2025": 0.01, "Default": 0.02 };
const TaxBracket: TaxBrackets = {
  "2025" : [0, 11309, 45985, 97962, 187200, 237714, 594360]
}
export const ASSUMPTIONS: Assumptions = {
  "MED": "1.45",
  "SSPect" : "6.2",
  "NECRates": NEC,
  "MBCBPRates": MBC_BP,
  "AssumptionByYear": {}
};

export const MONTH_NAMES = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

